import type { AccordionBlock, LocaleCode } from '@fixit/bozp-content';
import { type SyntheticEvent, useRef } from 'react';
import { resolveLocalized } from '../locale';

/** Interactive engagement widget — reports the first accordion expand via onInteract(block.id). */
export function AccordionBlockView({
  block,
  locale,
  onInteract,
}: {
  block: AccordionBlock;
  locale: LocaleCode;
  onInteract?: (widgetId: string) => void;
}) {
  const fired = useRef(false);
  const handleToggle = (e: SyntheticEvent<HTMLDetailsElement>) => {
    if (fired.current || !e.currentTarget.open) return;
    fired.current = true;
    onInteract?.(block.id);
  };
  return (
    <div data-block-type="accordion">
      {block.items.map((item, idx) => (
        <details key={idx} onToggle={handleToggle}>
          <summary>{resolveLocalized(item.q, locale)}</summary>
          <p>{resolveLocalized(item.a, locale)}</p>
        </details>
      ))}
    </div>
  );
}
